import { createAsyncThunk } from "@reduxjs/toolkit";
import { getInformedConsent } from "../../services/patient/patient.service";

export const fetchInformedConsent = createAsyncThunk(
  'informedConsent/fetchInformedConsent',  
  async ({patient_id}: {patient_id: string}, thunkAPI) => {    
    try {
      const data: any = await getInformedConsent(patient_id);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue('Error fetching patients');
    }
  }
);